<template>
    <div class="contactUs">
<!--      <div class="contactUs_title">-->
<!--      <div>{{companyList.company}}</div>-->
<!--        <div class="line_bottom"></div>-->
<!--      </div>-->

      <div class="contact-eql" style="text-align: left">
        <div class="contact-left">
          <div class="content_type">
          <h4 class="color_white">公司联系方式</h4>
<!--          <div class="company_line_bottom"></div>-->
<!--          <p class="para-w3-agileits">一站式智能管理平台,为产业楼宇提供服务的信息科技</p>-->
          <div class="contact_title margin_10">联系人</div>
          <div class="contact_content">{{companyList.contact}}</div>

          <div class="contact_title margin_10">公司电话</div>
          <div class="contact_content">{{companyList.tel}}</div>
          <div class="contact_title margin_10">公司邮箱</div>
          <div class="contact_content">{{companyList.mail}}</div>
          <div class="contact_title margin_10">公司地址</div>
          <div class="contact_content">{{companyList.address}}</div>
<!--            <img src="../../images/map.png" class="map">-->
            <baiduMapComponet class="map" :center="center"></baiduMapComponet>


          <!--<div class="w3ls-social-icons">-->
          <!--<a class="facebook" href="#"><span class="fa fa-facebook"></span></a>-->
          <!--<a class="twitter" href="#"><span class="fa fa-twitter"></span></a>-->
          <!--<a class="pinterest" href="#"><span class="fa fa-pinterest-p"></span></a>-->
          <!--<a class="linkedin" href="#"><span class="fa fa-linkedin"></span></a>-->
          <!--</div>-->
          </div>
        </div>
        <div class="contact-middle">

          <div class="contact-middle-top-content">
            <div class="content_type">
          <h4 class="color_white">售前咨询</h4>
          <div class="contact_flex margin_bottom">
            <div class="contact_flex_left">
            <div class="contact_title ">联系人</div>
            <div class="contact_content">{{saleList.contact}}</div>
            </div>
            <div >
              <div class="contact_title">咨询电话</div>
              <div class="contact_content">{{saleList.tel}}</div>
            </div>
          </div>
          <div class="contact_flex margin_bottom">
            <div class="contact_flex_left">
              <div class="contact_title">服务时间</div>
              <div class="contact_content">{{saleList.serviceTime}}</div>
            </div>
            <div>
              <div class="contact_title">咨询邮箱</div>
              <div class="contact_content">{{saleList.mail}}</div>
            </div>
          </div>

          <div class="contact_title">服务内容</div>
          <div class="contact_content">{{saleList.serviceContent}}</div>
            </div>
          </div>
          <div class="contact_bottom contact-middle-top-content">
            <div class="content_type">
            <h4 class="color_white">售后服务</h4>
            <div class="contact_flex margin_bottom">
              <div class="contact_flex_left">
                <div class="contact_title">联系人</div>
                <div class="contact_content">{{afterList.contact}}</div>
              </div>
              <div >
                <div class="contact_title">咨询电话</div>
                <div class="contact_content">{{afterList.tel}}</div>
              </div>
            </div>
            <div class="contact_flex margin_bottom">
              <div class="contact_flex_left">
                <div class="contact_title">服务时间</div>
                <div class="contact_content">{{afterList.serviceTime}}</div>
              </div>
              <div>
                <div class="contact_title">咨询邮箱</div>
                <div class="contact_content">{{afterList.mail}}</div>
              </div>
            </div>
            <div class="contact_title">服务内容</div>
            <div class="contact_content">{{afterList.serviceContent}}</div>
            </div>
          </div>


        </div>


      </div>


    </div>
</template>
<style src="./contactUs.css" scoped></style>

<script>
    import mixins from '../../common/mixin';
    import application from '../../common/application'
    import baiduMapComponet from "../baiduMap/baiduMap";

    export default {
        name: "contactUs",
        components:{
            baiduMapComponet
        },
        data:()=>({
            application:application,
            companyList:{},
            saleList:{},
            afterList:{},
            center: { lng: 116.404, lat: 39.915 },

        }),
        mixins:[mixins],
        created() {
            this.handleContactUs();
            this.handleSale();
            this.handleAfter();
        },
        methods:{
            //获取联系我们公司
            handleContactUs(){
                this.request({
                    url: '/web/contact/type',
                    data:{

                        "pageIndex": 0,
                        "pageSize": 1,
                        "type":'company',
                        "userId": 0

                    },
                    success: (response) => {
                        this.companyList=response.data.records[0];
                        console.log(this.companyList)
                        this.center.lng=this.companyList.lng;
                        this.center.lat=this.companyList.lat;

                    },
                    error: (response) => {
                        this.$Message.error(response.message);
                    },
                    complete: () => {
                    }
                });
            },
            //获取售前咨询
            handleSale(){
                this.request({
                    url: '/web/contact/type',
                    data:{

                        "pageIndex": 0,
                        "pageSize": 1,
                        "type":'before',
                        "userId": 0

                    },
                    success: (response) => {
                        this.saleList=response.data.records[0];
                        // console.log("saleList",this.saleList)

                    },
                    error: (response) => {
                        this.$Message.error(response.message);
                    },
                    complete: () => {
                    }
                });
            },
            //获取售后咨询
            handleAfter(){
                this.request({
                    url: '/web/contact/type',
                    data:{

                        "pageIndex": 0,
                        "pageSize": 1,
                        "type":'after',
                        "userId": 0

                    },
                    success: (response) => {
                        this.afterList=response.data.records[0];
                        // console.log("afterList",this.afterList)

                    },
                    error: (response) => {
                        this.$Message.error(response.message);
                    },
                    complete: () => {
                    }
                });
            },



        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/contactUs/contactUs.vue